import { FC, useMemo } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import { useTranslation } from 'react-i18next'
import { Alert } from '@carsys/ui'
import { IShopWholesaler } from '@cbgms/api'
import { isVPOMAXBE } from 'utils/Ordersystems/utils'

const mgFRfrUrl = 'https://begin.mongrossiste.fr/login'
const mgFRbeUrl = 'https://begin.mongrossiste.be/login'
const mgNLbeUrl = 'https://begin.mijngrossier.be/login'
const mgNLnlUrl = 'https://begin.mijngrossier.nl/login'

const appNameNL = 'Mijn Grossier'
const appNameFR = 'Mon Grossiste'

const determineParams = (country: string, locale: string) => {
  if (country === 'NL') {
    return { url: mgNLnlUrl, name: appNameNL }
  }
  if (country === 'FR') {
    return { url: mgFRfrUrl, name: appNameFR }
  }
  if (country === 'BE') {
    if (locale.startsWith('nl')) {
      return { url: mgNLbeUrl, name: appNameNL }
    }
    return { url: mgFRbeUrl, name: appNameFR }
  }
  return { url: mgNLnlUrl, name: appNameNL }
}

interface Props {
  onClose: () => void
  wholesaler: IShopWholesaler
}

export const DontKnowLoginDetailsDialogForMijnGrossier: FC<Props> = ({ onClose, wholesaler }) => {
  const { t, i18n } = useTranslation()
  const locale = i18n.language
  const systemName = t('Enum.EnumOrderSystem_MijnGrossier')
  const { url, name } = useMemo(() => {
    return determineParams(wholesaler.Country, locale)
  }, [wholesaler.Country, locale])
  return (
    <>
      <DialogContent>
        <Alert severity='info'>{t('Auth.Onboarding.dont-know-login-details-info-content', { name })}</Alert>
        <Box mt={1}>{t('Auth.Onboarding.mg-follow-password', { name })}</Box>
        <Box mt={1}>{t('Auth.Onboarding.mg-incognito-when-logged-in')}</Box>
        <Box mt={1} p={1} display='flex' justifyContent='center'>
          <a href={url} target='_blank'>
            {url}
          </a>
        </Box>
        {isVPOMAXBE(wholesaler) && <Box sx={{ whiteSpace: 'pre-line' }}>{t(`Auth.Onboarding.axbe-forgot-password`, { systemName })}</Box>}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} data-testid='btn-close-modal'>
          {t('global.close')}
        </Button>
        <Button href={url} color='primary' sx={{ ml: 1 }} data-testid='btn-redirect-modal' role='button'>
          {t('global.ok')}
        </Button>
      </DialogActions>
    </>
  )
}
